import React from 'react';

const CharSpaceBtn = (props) => (
    <div 
        key={props.index} 
        id={props.label} 
        className={props.selected ? "char-btn space on" : "char-btn space up"}
        style={{backgroundImage: `url(./images/sections/lc/chars/${props.selected ? `on` : `up`}/space.svg)`}}
        onClick={props.onClick}
    ></div>
);

export default CharSpaceBtn;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharSpaceBtn.js